import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex sm:items-center sm:justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "trezo-card-subtitle sm:flex sm:items-center" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "trezo-card-dropdown relative" }
const _hoisted_8 = { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }
const _hoisted_9 = { class: "trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:left-0 sm:ltr:right-0 rtl:right-0 sm:rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none" }
const _hoisted_10 = { class: "trezo-card-content" }
const _hoisted_11 = {
  key: 0,
  class: "py-8 text-center"
}
const _hoisted_12 = {
  class: "animate-spin inline-block w-8 h-8 border-[3px] border-current border-t-transparent text-primary-500 rounded-full",
  role: "status",
  "aria-label": "loading"
}
const _hoisted_13 = { class: "sr-only" }
const _hoisted_14 = {
  key: 1,
  class: "py-8 text-center text-gray-400 dark:text-gray-500"
}
const _hoisted_15 = {
  key: 2,
  class: "table-responsive overflow-x-auto"
}
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = { class: "text-black dark:text-white" }
const _hoisted_18 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_19 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_20 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_21 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_22 = { class: "font-medium text-left px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tr-md" }
const _hoisted_23 = { class: "text-black dark:text-white" }
const _hoisted_24 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_25 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = { class: "block font-medium" }
const _hoisted_28 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_29 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_30 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_31 = {
  key: 0,
  class: "px-[8px] py-[3px] inline-block bg-success-100 dark:bg-[#15203c] text-success-600 rounded-sm font-medium text-xs"
}
const _hoisted_32 = {
  key: 1,
  class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs"
}
const _hoisted_33 = {
  key: 2,
  class: "px-[8px] py-[3px] inline-block bg-warning-50 dark:bg-[#15203c] text-warning-500 rounded-sm font-medium text-xs"
}
const _hoisted_34 = {
  key: 3,
  class: "px-[8px] py-[3px] inline-block bg-danger-100 dark:bg-[#15203c] text-danger-500 rounded-sm font-medium text-xs"
}
const _hoisted_35 = {
  key: 4,
  class: "px-[8px] py-[3px] inline-block bg-gray-100 dark:bg-[#15203c] text-gray-600 rounded-sm font-medium text-xs"
}
const _hoisted_36 = { class: "px-[20px] py-[12px] md:py-[14px] rounded-b-md border-l border-r border-b border-gray-100 dark:border-[#172036] sm:flex sm:items-center justify-between" }
const _hoisted_37 = { class: "mb-0 text-sm" }
const _hoisted_38 = { class: "mt-[10px] sm:mt-0" }
const _hoisted_39 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.directT('dashboard.recentOrders')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          class: "relative sm:w-[240px] ltr:sm:mr-[20px] rtl:sm:ml-[20px] my-[13px] sm:my-0",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: _ctx.directT('common.search'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.searchTerm]
          ])
        ], 32),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block rounded-md border border-gray-100 py-[5px] md:py-[6.5px] px-[12px] md:px-[19px] transition-all hover:bg-gray-50 dark:border-[#172036] dark:hover:bg-[#0a0e19]': true,
              active: _ctx.isActive,
            }),
            id: "dropdownToggle",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, [
            _createElementVNode("span", _hoisted_8, [
              (_ctx.timeRange === 'day')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.directT('dashboard.thisDay')), 1)
                  ], 64))
                : (_ctx.timeRange === 'week')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.directT('dashboard.thisWeek')), 1)
                    ], 64))
                  : (_ctx.timeRange === 'month')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(_ctx.directT('dashboard.thisMonth')), 1)
                      ], 64))
                    : (_ctx.timeRange === 'year')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(_ctx.directT('dashboard.thisYear')), 1)
                        ], 64))
                      : _createCommentVNode("", true),
              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" }, null, -1))
            ])
          ], 2),
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectPeriod('day'))),
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, _toDisplayString(_ctx.directT('dashboard.thisDay')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectPeriod('week'))),
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, _toDisplayString(_ctx.directT('dashboard.thisWeek')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectPeriod('month'))),
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, _toDisplayString(_ctx.directT('dashboard.thisMonth')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectPeriod('year'))),
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, _toDisplayString(_ctx.directT('dashboard.thisYear')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.directT('common.loading') || 'Loading...'), 1)
            ])
          ]))
        : (_ctx.filteredItems.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.directT('common.noData') || 'No data available'), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _createElementVNode("thead", _hoisted_17, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.directT('dashboard.orderId')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.directT('dashboard.customer')), 1),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.directT('dashboard.created')), 1),
                    _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.directT('dashboard.total')), 1),
                    _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.directT('dashboard.status')), 1)
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.orderID
                    }, [
                      _createElementVNode("td", _hoisted_24, _toDisplayString(item.orderID), 1),
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(item.customer.name), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(item.created), 1),
                      _createElementVNode("td", _hoisted_29, " $" + _toDisplayString(item.total), 1),
                      _createElementVNode("td", _hoisted_30, [
                        (item.status.toLowerCase().includes('ship') || item.status.toLowerCase().includes('deliver'))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item.status), 1))
                          : (item.status.toLowerCase().includes('confirm') || item.status.toLowerCase().includes('process'))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(item.status), 1))
                            : (item.status.toLowerCase().includes('pend') || item.status.toLowerCase().includes('place'))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(item.status), 1))
                              : (item.status.toLowerCase().includes('cancel') || item.status.toLowerCase().includes('reject'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(item.status), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(item.status), 1))
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.directT('dashboard.showingResults').replace('{start}', String(_ctx.startItem + 1)).replace('{end}', String(_ctx.endItem)).replace('{total}', String(_ctx.filteredItems.length))), 1),
        _createElementVNode("ol", _hoisted_38, [
          _createElementVNode("li", {
            class: _normalizeClass(["inline-block mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0", { disabled: _ctx.currentPage === 1 }])
          }, [
            _createElementVNode("a", {
              href: "#",
              class: "w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border border-gray-100 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500",
              onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
            }, _cache[11] || (_cache[11] = [
              _createElementVNode("span", { class: "opacity-0" }, " 0 ", -1),
              _createElementVNode("i", { class: "material-symbols-outlined left-0 right-0 absolute top-1/2 -translate-y-1/2" }, " chevron_left ", -1)
            ]))
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["inline-block mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0", { active: _ctx.currentPage === page }]),
              key: page
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border border-gray-100 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500",
                onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
              }, _toDisplayString(page), 9, _hoisted_39)
            ], 2))
          }), 128)),
          _createElementVNode("li", {
            class: _normalizeClass(["inline-block mx-[3px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0", { disabled: _ctx.currentPage === _ctx.totalPages }])
          }, [
            _createElementVNode("a", {
              href: "#",
              class: "w-[31px] h-[31px] block leading-[29px] relative text-center rounded-md border border-gray-100 dark:border-[#172036] transition-all hover:bg-primary-500 hover:text-white hover:border-primary-500",
              onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
            }, _cache[12] || (_cache[12] = [
              _createElementVNode("span", { class: "opacity-0" }, " 0 ", -1),
              _createElementVNode("i", { class: "material-symbols-outlined left-0 right-0 absolute top-1/2 -translate-y-1/2" }, " chevron_right ", -1)
            ]))
          ], 2)
        ])
      ])
    ])
  ]))
}